import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalConfirmationComponent } from '../modals/confirmation/modal-confirmation.component';

@Component({
  selector: 'app-toggle-buttons',
  templateUrl: './toggle-buttons.component.html',
  styleUrls: ['./toggle-buttons.component.scss'],
})
export class ToggleButtonsComponent implements OnInit {
  @Input() options: string[] = [];

  @Input() initialValue?: string;
  @Input() selectFirst: boolean = false;

  @Output() optionChange = new EventEmitter<string>();

  currentOption: string | undefined;

  @Input({ transform: (value: any) => value !== false && value !== 'false' })
  confirmationNecessary: boolean = false;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    if (this.initialValue && this.options.includes(this.initialValue)) {
      this.currentOption = this.initialValue;
      this.optionChange.emit(this.currentOption);
    } else if (this.selectFirst && this.options.length > 0) {
      this.currentOption = this.options[0];
      this.optionChange.emit(this.currentOption);
    }
  }

  onOptionClick(newOption: string) {
    if (newOption === this.currentOption) {
      return;
    }

    if (this.confirmationNecessary) {
      this.openConfirmationModal(newOption);
    } else {
      this.currentOption = newOption;
      this.optionChange.emit(this.currentOption);
    }
  }

  openConfirmationModal(newOption: string) {
    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      data: {
        message: 'Tem certeza que deseja alterar a opção?',
        alertType: 'warning',
        showCancel: true,
        showConfirm: true,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.currentOption = newOption;
        this.optionChange.emit(this.currentOption);
      }
    });
  }
}
